var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 21.9999V19.0666C58.6667 14.9595 58.6667 12.906 57.8674 11.3373C57.1643 9.95747 56.0425 8.83561 54.6626 8.13254C53.0939 7.33325 51.0404 7.33325 46.9333 7.33325H41.0667C36.9596 7.33325 34.9061 7.33325 33.3374 8.13254C31.9575 8.83561 30.8357 9.95747 30.1326 11.3373C29.3333 12.906 29.3333 14.9595 29.3333 19.0666V21.9999M36.6667 42.1666V60.4999M51.3333 42.1666V60.4999M11 21.9999H77M69.6667 21.9999V63.0666C69.6667 69.2272 69.6667 72.3075 68.4677 74.6605C67.4131 76.7303 65.7303 78.413 63.6606 79.4677C61.3075 80.6666 58.2272 80.6666 52.0667 80.6666H35.9333C29.7728 80.6666 26.6925 80.6666 24.3394 79.4677C22.2697 78.413 20.5869 76.7303 19.5323 74.6605C18.3333 72.3075 18.3333 69.2272 18.3333 63.0666V21.9999",
    stroke: "#76A6CE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.acb5920276ec5b948084feb2ea83f689.svg";
export { ForwardRef as ReactComponent };